<template>
<!-- eslint-disable max-len -->
<div v-if="showExit" style="position: absolute; top: 0; left: 0; height: 100%; width: 100%;">
  <img
    :src="resolveAssetPath(activeEnvironment.gameEndBackground || game.gameEndBackground || 'EndGame_BG.png', 'backgrounds')"
    class="background"
  >
  <div :style="{
      display: 'flex',
      'flex-direction': 'column',
      'justify-content': 'space-between',
      'align-items': 'center',
      height: '74.5%',
      width: '34%',
      margin: '108px 31.26% 0'
    }"
  >
    <div class="titles">
      <!--
        Never use v-html with end-user generated content, because it's a vector for XSS attacks
        This is what the following lines used to be:
        <h1>{{ activeEnvironment.gameEndHeader || 'Congratulations!' }}</h1>
        <h2>{{ activeEnvironment.gameEndSubheader || 'You completed the Decision Rights Gamulation' }}</h2>
      -->
      <h2 v-html="activeEnvironment.gameEndHeader || 'Congratulations!'"></h2>
      <img :src="resolveAssetPath(activeEnvironment.gameEndLogo || 'https://assets.redmeru.com/eai/blade_logos/BLADE-FullWordmark-dark.jpg', 'ui/customer')" class="logo">
      <h2 v-html="activeEnvironment.gameEndSubheader || ''"></h2>
      <!--
      <div class="players">
        <img v-for="{ character } in players" :key="character._id" :src="resolveAssetPath(character.icon, 'characters')" class="icon">
      </div>
      -->
    </div>
    <transition enter-active-class="animated fadeIn">
      <a v-if="shouldUseQualtricsRedirect" class="btn end" :href="qualtricsRedirectURL">
        <span v-html="game.gameEndContinueButtonText || 'Continue'"></span>
      </a>
      <button v-else-if="showButton" @click.prevent.once="restart" class="btn end" v-focus key="home">
        <span v-html="game.gameEndButtonText || 'End'"></span>
      </button>
    </transition>
  </div>

  <div class="players">
    <!-- ordered based on z-order -->
    <narrator v-if="players.length > 4" :character="players[4].character" class="char5" :class="{ native, sf }" :variant-override="'Forward Right'"></narrator>
    <narrator v-if="players.length > 3" :character="players[3].character" class="char4" :class="{ native, sf }" :variant-override="'Forward Left'" left></narrator>
    <narrator v-if="players.length > 1" :character="players[1].character" class="char2" :class="{ native, sf }" :variant-override="'Forward Left'" left></narrator>
    <narrator v-if="players.length > 0" :character="gameEndCharacter || players[0].character" class="char1" :class="{ native, sf }" :variant-override="activeEnvironment.gameEndCharacterVariant || game.gameEndCharacterVariant || 'Forward Right'"></narrator>
    <narrator v-if="players.length > 2" :character="players[2].character" class="char3" :class="{ native, sf }" :variant-override="'Forward Right'"></narrator>
  </div>
</div>
<div v-else>
  <narrative-player v-if="showNarrative" :narratives="narratives" :on-complete="onNarrativePlayerComplete">
  </narrative-player>
</div>
</template>

<script>
import Vue from 'vue';
import { mapActions, mapGetters, mapMutations } from 'vuex';

import NarrativePlayer from '../narrative/NarrativePlayer';
import Narrator from '../ui/Narrator';

export default {
  components: {
    NarrativePlayer,
    Narrator
  },
  data() {
    return {
      showButton: false,
      showNarrative: false,
      narratives: null,
      allowExitFromOutro: false
    };
  },
  computed: {
    ...mapGetters([
      'isLti',
      'activeEnvironment',
      'activeSignInConfig',
      'selectedAvatar',
      'gameEndCharacter',
      'otherPlayers',
      'demo',
      'canRestartGame',
      'game',
      'group',
      'activeClass',
      'outro',
      'me',
      'starfighter',
      'native'
    ]),
    useCodeSignIn() {
      return this.activeSignInConfig.uniqueIdSignin || (this.me.registrationLinkUsed && this.me.registrationLinkUsed.uniqueIdSignin);
    },
    qualtricsRedirectURL() {
      let url = (this.activeSignInConfig && this.activeSignInConfig.qualtricsRedirectURL)
        ? this.activeSignInConfig.qualtricsRedirectURL
        : this.me.registrationLinkUsed.qualtricsRedirectURL
      ;

      console.log(this.me.registrationLinkUsed);
      // This is hardcoded for now, but we could definitely make it a bit more flexible
      if (url.includes('?')) {
        url += `&aid=${this.me.email}`;
      } else {
        url += `?aid=${this.me.email}`;
      }
      return url;
    },
    shouldUseQualtricsRedirect() {
      // const classId = this.activeClass ? this.activeClass._id : null;
      // const completedGame =
      //       classId
      //         ? (this.activeClass.outro
      //           ? null
      //           : (this.activeClass.completedGame || this.game.completedGame))
      //         : this.game.completedGame;

      return this.useCodeSignIn && this.qualtricsRedirectURL;
    },
    sf() {
      return this.starfighter;
    },
    players() {
      return [{ character: this.selectedAvatar }].concat(this.otherPlayers);
    },
    showExit() {
      return this.outro == null || this.allowExitFromOutro;
    }
  },
  methods: {
    ...mapActions([
      'archiveGroup',
      'getMyGroup',
      'playSound',
    ]),
    ...mapMutations([
      'setRootLoadingMessage',
    ]),
    async restart() {
      if (this.game.endButtonSound) this.playSound({ sound: this.game.endButtonSound });
      for (let i = 3; i > 0; --i) {
        try {
          const gameId = this.game ? this.game._id : null;
          const classId = this.activeClass ? this.activeClass._id : null;
          const completedGame =
            classId
              ? (this.activeClass.outro
                ? null
                : (this.activeClass.completedGame || this.game.completedGame))
              : this.game.completedGame;
          if (this.canRestartGame || !completedGame) {
            this.$router.push('/');
          } else {
            // automatically load into the complete game, if there is one and you can't restart...
            // block view with spinner to hide visual issue from group data change while not in Hub
            this.setRootLoadingMessage('Loading...');
            await this.getMyGroup({
              gameId, classId, requestCompleted: true,
            });
            if (this.group) {
              this.$router.push(`/groups/${this.group._id}`);
              if (!this.isLti) { this.$router.go(0); }
            } else {
              const message = 'Failed to start game';
              this.flashDanger({ message });
            }
            this.setRootLoadingMessage('');
          }
          return;
        } catch (err) {
          if (this.$router.handleGameError(err)) return;
        }
      }
      this.$router.showGameErrorCritical();
    },
    home() {
      this.$router.replace('/');
    },
    async onNarrativePlayerComplete() {
      // check for next class/game, if one exists, allow exit
      // otherwise loop on the outro forever!
      const { assignedGames, classes } = this.me;
      if (classes != null && classes.length > 0 && this.activeClass != null) {
        const index = classes.findIndex(({ _id }) => _id === this.activeClass._id);
        if (index + 1 < classes.length) { // not last in list
          this.allowExitFromOutro = true;
        }
      }
      if (!(this.allowExitFromOutro) && assignedGames != null && assignedGames.length > 0) {
        const index = assignedGames.findIndex(({ _id }) => _id === this.game._id);
        if (index + 1 < assignedGames.length) { // not last in list
          this.allowExitFromOutro = true;
        }
      }

      if (!(this.allowExitFromOutro)) { // restart outro
        this.showNarrative = false;
        this.narratives = null;
        await Vue.nextTick();
        this.narratives = this.outro.narratives;
        this.showNarrative = true;
      }
    }
  },
  mounted() {
    this.showButton = true;
    if (this.outro != null) {
      this.narratives = this.outro.narratives;
    }
    this.showNarrative = true;
  }
};
</script>

<style lang="scss" scoped>
.background {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  object-fit: contain;
  z-index: -10000;
}
.titles {
  background-color: var(--primaryColor);
  box-shadow: 0 0 100px rgba(0,0,0,1) inset;
  width: 100%;
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  border-radius: 15px;
  border: 1px solid var(--secondaryColor);
  padding: 10px;
}
.logo {
  margin: 0 0 30px;
  max-height: 270px;
  max-width: 90%;
  border-radius: 15px;
  object-fit: contain;
}
.titles h1 {
  font-size: 84px;
  font-weight: bold;
  color: black;
  margin: 0;
}
.titles h2 {
  font-size: 36px;
  font-weight: bold;
  color: white;
  margin-top: 10px;
  margin-bottom: 40px;
  padding: 0 10px;
  text-align: center;
}
.players {
  display: flex;
  flex-flow: row;
  align-items: center;
  justify-content: space-between;
}
.icon {
  background-color: white;
  width: 225px;
  max-height: 165px;
  object-fit: contain;
  margin: 10px;
}
.end {
  width: 250px;
  font-size: 36px;
  line-height: 54px;
}
.char1.native {
  transform: translate(-246px, -525px) scale(.42);
}
.char2.native {
  transform: translate(-1046px, -525px) scale(.42);
}
.char3.native {
  transform: translate(48px, -500px) scale(.43);
}
.char4.native {
  transform: translate(-1246px, -550px) scale(.41);
}
.char5.native {
  transform: translate(-115px, -555px) scale(.405);
}
.char1.sf {
  transform: translate(-246px, -225px) scale(.75);
}
.char2.sf {
  transform: translate(-1046px, -225px) scale(.75);
}
.char3.sf {
  transform: translate(48px, -200px) scale(.76);
}
.char4.sf {
  transform: translate(-1246px, -250px) scale(.74);
}
.char5.sf {
  transform: translate(-115px, -255px) scale(.735);
}
</style>



// WEBPACK FOOTER //
// src/components/game/pages/GameEnd.vue